import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
// interfaces
import { UseRecaptchaV3Result, ExecuteRecaptchaOptions } from 'interfaces';
import { RECAPTCHA_FAILED_TO_GENERATE_TOKEN_TEXT, RECAPTCHA_NOT_READY_TEXT } from 'constants/index';

export const useRecaptchaV3 = (): UseRecaptchaV3Result => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const execute = useCallback(
    async (options?: ExecuteRecaptchaOptions): Promise<string> => {
      const action = options?.action ?? 'generic';
      if (!executeRecaptcha) {
        throw new Error(RECAPTCHA_NOT_READY_TEXT);
      }
      const token = await executeRecaptcha(action);
      if (!token) {
        throw new Error(RECAPTCHA_FAILED_TO_GENERATE_TOKEN_TEXT);
      }
      return token;
    },
    [executeRecaptcha],
  );

  return { isReady: Boolean(executeRecaptcha), execute };
};
